import React, {useEffect, useLayoutEffect, useState} from 'react';
import {ContentHeader} from '@app/components';
import AppButton from '@app/components/button/Button';
import PoshInputs from '@app/components/Forms/InputForms/Inputs';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import swal from 'sweetalert';

function EditCodeGeneration() {
  const navigation = useNavigate();
  const [parent, setParent] = useState<number>()
  const [displayBoxes, setDisplayBoxes] = useState<number>()
  const [devicePerBoxes, setDevicePerBoxes] = useState<number>()
  const [Disable, setDisabled] = useState(true);

  useEffect(() => {
    if (parent && displayBoxes ){
      setDisabled(false)
    }else{
      setDisabled(true)
    }
    
  }, [parent,displayBoxes])

 const onSubmit = async() => {
  const model = await swal({
    title: 'Are you sure ?',
    text: 'You want to add edit generation ?',
    icon: 'warning',
    buttons: [true, true],
    dangerMode: true,
    closeOnClickOutside: false
  });

  if (!model) return;
  navigation(-1)
 }
  return (
    <div>
      <ContentHeader title="Edit Code Generation" />
      <section className=" bg-white p-4 rounded m-3">
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="inputWrapper">
            <PoshInputs
              title="Formantion"
              validate={"*"}
              value={parent}
              onChange={(e: any) => {
                setParent(e.target.value);
              }}
              type={'number'}
              hideControl
              readOnly={true}
            />
            <PoshInputs
              title="No of codes"
              validate={"*"}
              onChange={(e: any) => {
                setDisplayBoxes(e.target.value);
              }}
              value={displayBoxes}
              type={'number'}
              hideControl
              suggestedNo={"993889"}
              readOnly={true}
            />
          </div>
          <div className="inputWrapper">
            <PoshInputs
              title="No of complete cases"
              validate={"*"}
              onChange={(e: any) => {
                setDevicePerBoxes(e.target.value);
              }}
              value={"3088"}
              type={'number'}
              hideControl
              readOnly={true}
              disabled={true}
            />
            <PoshInputs
              disabled={true}
              title="Remaining extra codes"
              validate={"*"}
              value={"12"}
              type={'number'}
              hideControl
              readOnly={false}
            />
          </div>
          <div
            className="d-flex justify-content-end"
            style={{marginRight: '7px'}}
          >
            <AppButton
              children={'Cancel'}
              className="btn btn-light mr-3"
              onClick={() => {
                navigation(-1);
              }}
            />
            <AppButton
              children={'Save'}
              disabled={Disable}
              onClick={() => {
                onSubmit()
              }}
            />
          </div>
        </form>
      </section>
    </div>
  );
}

export default EditCodeGeneration;
